import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  formControlLabel: {
    alignItems: 'flex-start',
    '& .MuiCheckbox-root': {
      padding: 0,
      marginTop: theme.spacing(-0.25),
    },
  },
  formControlLabelError: {
    alignItems: 'flex-start',
    '& .MuiCheckbox-root': {
      padding: 0,
      marginTop: theme.spacing(-0.25),
      color:theme.palette.error.dark
    },
  },
}))

export default useStyles
